(() => {
  const ROOT = '[data-vael-wear-with]';

  // Rendered inside the buy-buttons block so we do not have to edit the very
  // large main-product__info-blocks.liquid. .product__content is a flex column,
  // so appending places it beneath the accordions where it belongs.
  // Complete the set (data-vael-ww-inline) is the exception: it stays where it
  // is rendered, directly under the buy buttons.
  function place(root) {
    if (root.hasAttribute('data-vael-ww-inline')) {
      root.classList.add('is-placed');
      return;
    }
    const column = root.closest('.product__content');
    if (column && root.parentElement !== column) {
      column.appendChild(root);
    }
    root.classList.add('is-placed');
  }

  async function refreshCartCount() {
    try {
      const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const res = await fetch(base + 'cart.js');
      if (!res.ok) return;
      const cart = await res.json();
      document
        .querySelectorAll('[data-cart-count], .cart-count, .header__cart-count')
        .forEach((el) => {
          el.textContent = cart.item_count;
        });
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } })
      );
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    } catch (e) {
      /* non-fatal — the item is in the cart either way */
    }
  }

  function initItem(item) {
    const select = item.querySelector('[data-vael-ww-select]');
    const button = item.querySelector('[data-vael-ww-add]');
    const status = item.querySelector('[data-vael-ww-status]');
    if (!button) return;

    const clearStatus = () => {
      if (!status) return;
      status.textContent = '';
      status.removeAttribute('data-state');
    };

    // Single variant products (caps, scarves, the tote) carry the variant id on
    // the button itself and have no size selector.
    const singleVariantId = button.getAttribute('data-variant-id');

    if (select) {
      select.addEventListener('change', () => {
        button.disabled = !select.value;
        clearStatus();
      });
    }

    button.addEventListener('click', async () => {
      const id = singleVariantId || (select && select.value);
      if (!id) return;

      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding';
      clearStatus();

      try {
        const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const res = await fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        });

        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          throw new Error(data.description || data.message || 'Could not add to cart');
        }

        button.textContent = 'Added';
        if (status) status.textContent = 'Added to your cart.';

        await refreshCartCount();

        window.setTimeout(() => {
          button.textContent = original;
          clearStatus();
          if (select) {
            select.selectedIndex = 0;
            button.disabled = true;
          } else {
            button.disabled = false;
          }
        }, 2600);
      } catch (err) {
        button.textContent = original;
        button.disabled = false;
        if (status) {
          status.textContent = err.message || 'Could not add to cart. Please try again.';
          status.setAttribute('data-state', 'error');
        }
      }
    });
  }

  function init(scope) {
    const target = scope || document;
    const roots = target.querySelectorAll ? target.querySelectorAll(ROOT) : [];
    roots.forEach((root) => {
      if (root.dataset.vaelWwInit === 'true') return;
      root.dataset.vaelWwInit = 'true';
      place(root);
      root.querySelectorAll('.vael-wear-with__item').forEach(initItem);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
